import { render, staticRenderFns } from "./user-wizard-user-type-field.vue?vue&type=template&id=e55e5d8c"
import script from "./user-wizard-user-type-field.vue?vue&type=script&lang=js"
export * from "./user-wizard-user-type-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports